import React, { useEffect, useState } from 'react';
import { Modal } from 'client/components/common/Modal';
import { AreaTreeQuery } from 'src/client/generated';
import { PrefecturesList } from 'client/components/recruitments/Modal/AreaModal/PrefecturesList';
import { RegionList } from 'client/components/recruitments/Modal/AreaModal/RegionList';

type Props = {
  areaTreeData: AreaTreeQuery | undefined;
  areaIds?: string[];
  handlers: {
    handleClickClose: () => void;
    handleClickClear: () => void;
  };
};

export const AreaModal = ({ areaTreeData, areaIds, handlers: { handleClickClear, handleClickClose } }: Props) => {
  // モーダル変更用
  const [areaModalUI, setAreaModalUI] = useState<'region' | 'prefectures'>('region');

  // モーダル遷移用の状態管理
  const [selectedRegion, setSelectedRegion] = useState('');

  const regions = areaTreeData?.areaTree.regions;

  const closeClick = () => {
    handleClickClose();
    setSelectedRegion('');
  };

  useEffect(() => {
    // もしエリアツリーで地方が1つの場合、都道府県選択に自動遷移
    if (regions?.length == 1) {
      setSelectedRegion(regions[0].id);
      setAreaModalUI('prefectures');
    }
  }, [regions]);

  return (
    <Modal
      title="エリア"
      onClose={areaIds?.length ? closeClick : undefined}
      onClear={areaModalUI === 'region' ? null : handleClickClear}
      dataTestId={'region-and-prefecture-modal'}
    >
      {areaModalUI === 'region' && regions?.length !== 1 && (
        <RegionList areaTreeData={areaTreeData} setSelectedRegion={setSelectedRegion} setAreaModalUI={setAreaModalUI} />
      )}

      {areaModalUI === 'prefectures' && <PrefecturesList selectedRegion={selectedRegion} areaTreeData={areaTreeData} />}
    </Modal>
  );
};
